export default __webpack_public_path__ + "static/pic2-7101039f2897fc03e4fcd78d35a950bc.png";